module.exports = __webpack_public_path__ + "static/media/gts08.086ed5d0.png";